import { render } from "./AposAreaMenuItem.vue?vue&type=template&id=8e5687d4&scoped=true"
import script from "./AposAreaMenuItem.vue?vue&type=script&lang=js"
export * from "./AposAreaMenuItem.vue?vue&type=script&lang=js"

import "./AposAreaMenuItem.vue?vue&type=style&index=0&id=8e5687d4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e5687d4"],['__file',"area/ui/apos/components/AposAreaMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8e5687d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8e5687d4', __exports__)) {
    api.reload('8e5687d4', __exports__)
  }
  
  module.hot.accept("./AposAreaMenuItem.vue?vue&type=template&id=8e5687d4&scoped=true", () => {
    api.rerender('8e5687d4', render)
  })

}


export default __exports__